import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import Slider from 'react-slick';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'slick-carousel/slick/slick.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'slick-carousel/slick/slick-theme.css';
import LandingEventCard from '../../LandingEventCard';
import EventDTO from '../../../models/event';
import useNavigateWithQuery from '../../../hooks/useNavigateWithQuery';
import './Carrousel-cards.css';
import useIsMobile from '../../../hooks/useIsMobile';
import getToastColor from '../../../utils/getToastColor';
import getToastText from '../../../utils/getToastText';

interface Props {
  cards: EventDTO[];
  handleEventSelect?: (eventId: string) => void;
}

const CarrouselCards: React.FC<Props> = ({ cards, handleEventSelect }) => {
  const navigate = useNavigateWithQuery();
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3.1,
    slidesToScroll: 1,
    arrows: !useIsMobile(),
    autoplay: !handleEventSelect,
    autoplaySpeed: 5000,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.1,
        },
      },
    ],
  };

  const onSelect = (eventId: string) => {
    if (handleEventSelect) {
      handleEventSelect(eventId);
    } else {
      navigate(`/events/${eventId}`);
    }
  };
  return (
    <div className='-mx-4'>
      <Slider {...settings}>
        {cards.map((card, index) => (
          <div key={index} className='w-[90%] lg:w-full relative p-2 lg:p-4'>
           <LandingEventCard event={card} onSelect={onSelect} textButton={handleEventSelect ? 'Ver evento' : 'Adquirir entradas'} textToast={handleEventSelect ? getToastText(card.public_status) : ''} colorToast={handleEventSelect ? getToastColor(card.public_status) : ''}/>
          </div>))}
      </Slider>
    </div>
  );
};

export default CarrouselCards;
